import React, { PropsWithChildren, useState } from 'react';

interface TabPanelProps {
  label?: string;
  children: React.ReactNode;
}

export const TabPanel: React.FC<TabPanelProps> = ({ children }) => {
  return <div className="tab-panel">{children}</div>;
};

const Tab: React.FC<
  PropsWithChildren<{
    onClick: () => void;
    isActive: boolean;
  }>
> = ({ children, onClick, isActive }) => {
  return (
    <button onClick={onClick} className={`tab ${isActive ? 'active' : ''}`}>
      {children}
    </button>
  );
};

const TabsBlock: React.FC<PropsWithChildren> = ({ children }) => {
  const [activeTab, setActiveTab] = useState(
    (children as React.ReactElement[])[0]?.props.label,
  );

  return (
    <div className="tabs-block">
      <div className="tabs-holder">
        <div className="tab-list">
          {Array.isArray(children) &&
            children?.map(child => {
              const { label } = child.props;

              return (
                <Tab
                  key={label}
                  isActive={activeTab === label}
                  onClick={() => setActiveTab(label)}
                >
                  {label}
                </Tab>
              );
            })}
        </div>

        <div className="tab-panels">
          {Array.isArray(children) &&
            children.map(child => {
              const { label } = child.props;
              if (label !== activeTab) return undefined;

              return <React.Fragment key={label}>{child}</React.Fragment>;
            })}
        </div>
      </div>
    </div>
  );
};

export default TabsBlock;
